import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const AdminCLogoInverse32Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1406 1025q0 26-10 49t-27 40-40 27-49 10V898q26 0 49 10t40 27 27 41 10 49zm611 84l-63 239-209-28q-17 26-36 50t-40 46l73 190-213 124-127-166q-30 8-60 11t-62 4v-209q71 0 134-27t110-73 74-110 27-134q0-71-27-134t-74-110-109-74-135-27V467h5l79-178 238 63-26 203q26 17 51 37t47 43l186-71 124 213-165 127q6 31 9 61t4 62l185 82zM64 273L1216 68v1912L64 1781V273zm676 354q-93 0-164 31t-119 86-73 130-25 165q0 83 21 152t65 120 108 77 153 28q38 0 77-5t75-23v-162q-72 43-155 43-53 0-91-20t-63-53-37-77-12-92q0-51 13-96t40-80 67-55 97-20q38 0 73 9t68 30V644q-29-10-58-13t-60-4z" />
    </svg>
  ),
  displayName: 'AdminCLogoInverse32Icon',
});

export default AdminCLogoInverse32Icon;
